<template>
  <div :class="['notifications-button']" @click="showModal">
    <BbIcon class="notifications-icon" name="notification" />
    <div v-if="unreadNotifications.length" class="notifications-count">
      {{ unreadNotifications.length }}
    </div>
  </div>
</template>

<script>
import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import useModals from '~/composables/useModals';
import useNotifications from '~/composables/useNotifications';
import { CURRENT_DIALOG } from '~/constants/conversationModels';

export default {
  name: 'NotificationsMenu',
  components: {},

  setup() {
    const store = useStore();
    const { setCurrentDocumentsDialog } = useModals();
    const { notifications } = useNotifications();
    const unreadNotifications = computed(() => notifications.value.filter((n) => !n.readAt));
    const showModal = () => {
      setCurrentDocumentsDialog(CURRENT_DIALOG.notifications_panel);
    };

    watch(unreadNotifications, (newValue) => {
      newValue.forEach((notification) => {
        if (notification.actionName === 'Download' && notification.downloadId) {
          store.dispatch('documentStore/removeDownloadInProgress', notification.downloadId);
        }
      });
    });

    return {
      showModal,
      unreadNotifications,
    };
  },
};
</script>

<style scoped lang="scss">
.notifications-button {
  position: relative;
  padding: $bb-spacing-2;
  border-radius: 8px;
  cursor: pointer;
  line-height: 1;

  &:hover,
  &.active {
    background: $bb-interface-8;
  }

  .notifications-icon {
    color: $bb-neutral-1;
  }

  .notifications-count {
    @include bb-medium-text-styles('xs');
    color: $bb-neutral-0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 3px;
    left: 21px;
    width: 17px;
    height: 17px;
    background: $bb-interface-5;
    border: 1px solid $bb-neutral-0;
    border-radius: 100px;
  }
}
</style>
